import type { ConnectionType } from '@sembo-private/maps';

import { createIngredientId } from '@libs/trip-planner-interfaces';
import type {
  IngredientId,
  IngredientType,
} from '@libs/trip-planner-interfaces';

import { DEFAULT_TRANSPORT_TYPE } from '../../helpers/transports';
import { uniqueIdGenerator } from '../../helpers/uniqueIdGenerator';

export abstract class BaseIngredient {
  public readonly ingredientId: IngredientId;
  public isNewIngredient = false;
  public transportTypeToBeReached: ConnectionType = DEFAULT_TRANSPORT_TYPE;

  constructor(public readonly ingredientType: IngredientType) {
    this.ingredientId = createIngredientId(uniqueIdGenerator());
  }

  public abstract isIngredientCorrect(): boolean;
}
